export const stripHtmlTags = (value) => {
	// Remove HTML tags from string
	return value.replace(/<[^>]*>/g, '');
};
